import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { BackOfficeRole } from "../../../enum/shared/backoffice-role.enum";
import { PolicyModel } from "../../../model/shared/policy.model";
import { FirestoreService } from "../../../service/api/auth/firestore.service";
import { ConfirmModalComponent } from "../../shared/confirm-modal/confirm-modal.component";
import { EditRoleModalComponent } from "../edit-role-modal/edit-role-modal.component";

@Component({
    selector: "bo-role-operation",
    templateUrl: "./role-operation.component.html",
    styleUrls: ["./role-operation.component.scss"]
})

export class RoleOperationComponent implements OnInit {
    @ViewChild("confirm") confirmModal: ConfirmModalComponent;
    @ViewChild("editRole") editRoleModal: EditRoleModalComponent;

    @Input() rowData: PolicyModel;
    data: PolicyModel;

    constructor(private readonly firestoreService: FirestoreService) { }

    ngOnInit(): void {
        this.data = this.rowData;
    }

    removeRole(): void {
        this.confirmModal.show();
    }

    async onRemoveRole(): Promise<void> {
        await this.firestoreService.deleteDocument(environment.firebaseConfig.policyCollection, this.data.id);
    }

    canEditUserRole(): boolean {
        // Superuser
        if (this.data.currentUserRole === BackOfficeRole.SuperUser) {
            return true;
        } else if (this.data.currentUserRole === BackOfficeRole.Administrator) {
            // Administrator
            if (this.data.userRole !== BackOfficeRole.SuperUser && this.data.userRole !== BackOfficeRole.Administrator) {
                return true;
            }
        } else {
            // Moderator
            return false;
        }
    }

    onEditUserRole(): void {
        this.editRoleModal.openModal();
    }
}